"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _ColorPicker = _interopRequireDefault(require("react-colorpicker/ColorPicker"));

var _DynoEditorSuggestedColors = _interopRequireDefault(require("./DynoEditorSuggestedColors"));

var _SimpleTextInputWithValidation = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleTextInputWithValidation"));

var _ImageUploadManager = _interopRequireDefault(require("./FileManager/ImageUploadManager"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _DynoTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoTypes"));

var _userInfo = require("hub-http/userInfo");

var _RedirectOptions = _interopRequireDefault(require("./dynoThankYouPanel/RedirectOptions"));

var _UIColorInput = _interopRequireDefault(require("UIComponents/color/UIColorInput"));

var _UIFireAlarm = _interopRequireDefault(require("UIComponents/alert/UIFireAlarm"));

var _UIRadioInput = _interopRequireDefault(require("UIComponents/input/UIRadioInput"));

var _UIToggle = _interopRequireDefault(require("UIComponents/input/UIToggle"));

var _RichTextEditor = _interopRequireDefault(require("lead-flows-ui/components/common/RichTextEditor"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _DynoValidation = require("lead-flows-ui/constants/DynoValidation");

var _DynoValidationUtils = require("lead-flows-ui/utils/Validation/DynoValidationUtils");

var _CALLOUT_DESCRIPTION_;

var CALLOUT_DESCRIPTION_TYPE_MAPPING = (_CALLOUT_DESCRIPTION_ = {}, (0, _defineProperty2.default)(_CALLOUT_DESCRIPTION_, _DynoTypes.default.TOP, false), (0, _defineProperty2.default)(_CALLOUT_DESCRIPTION_, _DynoTypes.default.BOTTOM_RIGHT, true), (0, _defineProperty2.default)(_CALLOUT_DESCRIPTION_, _DynoTypes.default.BOTTOM_LEFT, true), (0, _defineProperty2.default)(_CALLOUT_DESCRIPTION_, _DynoTypes.default.POP_OVER, true), _CALLOUT_DESCRIPTION_);

var DynoCalloutPanel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DynoCalloutPanel, _Component);
  (0, _createClass2.default)(DynoCalloutPanel, null, [{
    key: "propTypes",
    get: function get() {
      return {
        type: _react.default.PropTypes.oneOf(Object.keys(_DynoTypes.default || {})).isRequired,
        updateDyno: _react.default.PropTypes.func.isRequired,
        addValidationError: _react.default.PropTypes.func.isRequired,
        removeValidationError: _react.default.PropTypes.func.isRequired,
        validation: _react.default.PropTypes.object.isRequired,
        suggestedColors: _react.default.PropTypes.array.isRequired,
        fetchingSuggestedColors: _react.default.PropTypes.bool.isRequired,
        dismissButtonEnabled: _react.default.PropTypes.bool.isRequired,
        heading: _react.default.PropTypes.string,
        description: _react.default.PropTypes.string,
        ctaText: _react.default.PropTypes.string,
        formDescription: _react.default.PropTypes.string,
        formCta: _react.default.PropTypes.string,
        color: _react.default.PropTypes.string,
        imageUrl: _react.default.PropTypes.string,
        handleImageChange: _react.default.PropTypes.func.isRequired,
        gates: _react.default.PropTypes.object.isRequired,
        allGates: _react.default.PropTypes.array.isRequired,
        calloutButtonType: _react.default.PropTypes.string,
        hasCOSAccess: _react.default.PropTypes.bool,
        redirectUrl: _react.default.PropTypes.string,
        redirectButtonType: _react.default.PropTypes.string,
        isUngatedForFormlessPopups: _react.default.PropTypes.bool
      };
    }
  }]);

  function DynoCalloutPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DynoCalloutPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DynoCalloutPanel).call(this, props));
    _this.changeType = _this.changeType.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChangeHeading = _this.handleChangeHeading.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChangeCtaText = _this.handleChangeCtaText.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleUpdateColor = _this.handleUpdateColor.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDescriptionChange = _this.handleDescriptionChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.validateField = _this.validateField.bind((0, _assertThisInitialized2.default)(_this));
    _this.addValidationError = _this.addValidationError.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeValidationError = _this.removeValidationError.bind((0, _assertThisInitialized2.default)(_this));
    _this.removeAllOtherErrors = _this.removeAllOtherErrors.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DynoCalloutPanel, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.leadFlowCalloutEditor." + suffix;
    }
  }, {
    key: "errorLangKey",
    value: function errorLangKey() {
      return this.langKey('error.');
    }
  }, {
    key: "addValidationError",
    value: function addValidationError(field, message) {
      this.props.addValidationError(field, message, _DynoEditor.STEPS.CALLOUT);
    }
  }, {
    key: "removeValidationError",
    value: function removeValidationError(field) {
      this.props.removeValidationError(field, _DynoEditor.STEPS.CALLOUT);
    }
  }, {
    key: "removeAllOtherErrors",
    value: function removeAllOtherErrors(field) {
      this.props.removeValidationError(field, _DynoEditor.STEPS.THANKS);
      this.props.removeValidationError(field, _DynoEditor.STEPS.FORM);
      this.props.removeValidationError(field, _DynoEditor.STEPS.KICKBACK);
    }
  }, {
    key: "validateField",
    value: function validateField(dyno, validate) {
      var _this$props = this.props,
          addValidationError = _this$props.addValidationError,
          removeValidationError = _this$props.removeValidationError;
      var errors = validate(dyno, this.errorLangKey());
      var field = Object.keys(dyno)[0];
      removeValidationError(field);

      if (errors.length) {
        errors.forEach(function (error) {
          return addValidationError.apply(null, (0, _toConsumableArray2.default)(error));
        });
      }

      return errors;
    }
  }, {
    key: "changeType",
    value: function changeType(newType) {
      var _this$props2 = this.props,
          type = _this$props2.type,
          updateDyno = _this$props2.updateDyno;

      if (type === newType) {
        return;
      }

      updateDyno({
        type: newType
      });
    }
  }, {
    key: "handleChangeHeading",
    value: function handleChangeHeading(_ref) {
      var value = _ref.target.value;
      var updated = {
        heading: value
      };
      this.props.updateDyno(updated);
      this.validateField(updated, _DynoValidationUtils.validateCalloutHeading);
    }
  }, {
    key: "handleDescriptionChange",
    value: function handleDescriptionChange(value) {
      this.props.updateDyno({
        description: value.html
      });
      this.validateField({
        description: value.plainText
      }, _DynoValidationUtils.validateCalloutDescription);
    }
  }, {
    key: "handleChangeCtaText",
    value: function handleChangeCtaText(_ref2) {
      var value = _ref2.target.value;
      var updated = {
        cta: value
      };
      this.props.updateDyno({
        cta: value
      });
      this.validateField(updated, _DynoValidationUtils.validateCtaText);
    }
  }, {
    key: "handleUpdateColor",
    value: function handleUpdateColor(color) {
      color = typeof color === 'string' ? color : color.target.value;
      this.props.updateDyno({
        color: color
      });
      this.validateField({
        color: color
      }, _DynoValidationUtils.validateColor);
    }
  }, {
    key: "maybeRenderLeftRightChoice",
    value: function maybeRenderLeftRightChoice() {
      var _this2 = this;

      if (!this.props.gates['Leadin:Embedded'] || this.props.type !== _DynoTypes.default.BOTTOM_RIGHT && this.props.type !== _DynoTypes.default.BOTTOM_LEFT) {
        return null;
      }

      return _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('pickSlideInOrigin')
        })
      }, _react.default.createElement("div", null, _react.default.createElement(_UIRadioInput.default, {
        inline: true,
        name: "left",
        onChange: function onChange() {
          return _this2.changeType(_DynoTypes.default.BOTTOM_LEFT);
        },
        checked: this.props.type === _DynoTypes.default.BOTTOM_LEFT,
        text: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('bottomLeft')
        })
      }), _react.default.createElement(_UIRadioInput.default, {
        inline: true,
        name: "right",
        onChange: function onChange() {
          return _this2.changeType(_DynoTypes.default.BOTTOM_RIGHT);
        },
        checked: this.props.type === _DynoTypes.default.BOTTOM_RIGHT,
        text: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('bottomRight')
        })
      })));
    }
  }, {
    key: "maybeRenderImageWarning",
    value: function maybeRenderImageWarning() {
      var removeValidationError = this.props.removeValidationError;
      if (!this.props.validation.imageUrl) return null;
      return _react.default.createElement(_UIFireAlarm.default, {
        closeable: true,
        onClose: function onClose() {
          removeValidationError('imageUrl');
        },
        titleText: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('error.invalidUrl')
        }),
        type: "warning"
      }, _react.default.createElement("div", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('error.invalidUrlText')
      })));
    }
  }, {
    key: "maybeRenderImageUpload",
    value: function maybeRenderImageUpload() {
      var _typeMapping;

      var _this$props3 = this.props,
          handleImageChange = _this$props3.handleImageChange,
          imageUrl = _this$props3.imageUrl,
          type = _this$props3.type,
          removeValidationError = _this$props3.removeValidationError;
      var typeMapping = (_typeMapping = {}, (0, _defineProperty2.default)(_typeMapping, _DynoTypes.default.TOP, false), (0, _defineProperty2.default)(_typeMapping, _DynoTypes.default.BOTTOM_RIGHT, true), (0, _defineProperty2.default)(_typeMapping, _DynoTypes.default.BOTTOM_LEFT, true), (0, _defineProperty2.default)(_typeMapping, _DynoTypes.default.POP_OVER, true), _typeMapping);

      if (typeMapping[type]) {
        return _react.default.createElement(_UIFormControl.default, {
          label: _react.default.createElement(_FormattedMessage.default, {
            message: this.langKey('featuredImageSelectorHeader')
          }),
          tooltip: _react.default.createElement(_FormattedMessage.default, {
            message: this.langKey('featuredImageTooltip')
          })
        }, _react.default.createElement(_ImageUploadManager.default, {
          addValidationError: this.addValidationError,
          auth: (0, _userInfo.userInfoSync)(),
          imageUrl: imageUrl,
          onChange: handleImageChange,
          removeValidationError: removeValidationError
        }));
      }

      return null;
    }
  }, {
    key: "maybeRenderCalloutDescription",
    value: function maybeRenderCalloutDescription(type, validation, descriptionNotNull) {
      if (CALLOUT_DESCRIPTION_TYPE_MAPPING[type]) {
        return _react.default.createElement(_UIFormControl.default, {
          id: "dyno-callout-description",
          label: _react.default.createElement(_FormattedMessage.default, {
            message: this.langKey('bodyTextHeader')
          }),
          error: validation.description,
          validationMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.description)
        }, _react.default.createElement(_RichTextEditor.default, {
          gates: this.props.allGates,
          contents: descriptionNotNull,
          id: 'rich-text-editor-callout',
          onChange: this.handleDescriptionChange,
          minHeight: 130,
          shrink: true
        }));
      }

      return null;
    }
  }, {
    key: "maybeRenderConsciousCancel",
    value: function maybeRenderConsciousCancel() {
      if (!this.props.gates['Leadin:ConsciousCancel']) {
        return null;
      }

      var _this$props4 = this.props,
          dismissButtonEnabled = _this$props4.dismissButtonEnabled,
          updateDyno = _this$props4.updateDyno;
      return _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('consciousCancelHeader')
        })
      }, _react.default.createElement(_UIToggle.default, {
        checked: dismissButtonEnabled,
        size: "small",
        onChange: function onChange(_ref3) {
          var checked = _ref3.target.checked;
          updateDyno({
            dismissButtonEnabled: checked
          });
        }
      }));
    }
  }, {
    key: "renderFormlessPopupsOptions",
    value: function renderFormlessPopupsOptions() {
      var _this$props5 = this.props,
          validation = _this$props5.validation,
          redirectUrl = _this$props5.redirectUrl,
          hasCOSAccess = _this$props5.hasCOSAccess,
          updateDyno = _this$props5.updateDyno,
          allGates = _this$props5.allGates;
      return _react.default.createElement(_RedirectOptions.default, {
        hasCOSAccess: hasCOSAccess,
        redirectUrl: redirectUrl,
        updateDyno: updateDyno,
        validation: validation,
        addValidationError: this.addValidationError,
        removeValidationError: this.removeValidationError,
        removeAllOtherErrors: this.removeAllOtherErrors,
        allGates: allGates,
        isFromCallout: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          type = _this$props6.type,
          validation = _this$props6.validation,
          heading = _this$props6.heading,
          description = _this$props6.description,
          ctaText = _this$props6.ctaText,
          color = _this$props6.color,
          suggestedColors = _this$props6.suggestedColors,
          fetchingSuggestedColors = _this$props6.fetchingSuggestedColors,
          isUngatedForFormlessPopups = _this$props6.isUngatedForFormlessPopups; // `description` might be `null`, which we cannot give as a value to input components.

      var descriptionNotNull = description || '';
      var maybeImageUpload = this.maybeRenderImageUpload();
      var maybeCalloutDescription = this.maybeRenderCalloutDescription(type, validation, descriptionNotNull);
      return _react.default.createElement("div", {
        className: "dyno-callout-panel"
      }, this.maybeRenderLeftRightChoice(), this.maybeRenderImageWarning(), maybeImageUpload, _react.default.createElement(_SimpleTextInputWithValidation.default, {
        id: "dyno-callout-heading",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('calloutTextHeader')
        }),
        labelTooltip: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('calloutTextTooltip')
        }),
        isInvalid: !(0, _ValidationUtils.isValid)(validation, 'heading'),
        invalidMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.heading, {
          HEADING_MAX_LENGTH: _DynoValidation.HEADING_MAX_LENGTH
        }),
        value: heading,
        onChange: this.handleChangeHeading
      }), maybeCalloutDescription, _react.default.createElement(_SimpleTextInputWithValidation.default, {
        id: "dyno-callout-cta",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('buttonTextHeader')
        }),
        labelTooltip: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('buttonTextTooltip')
        }),
        isInvalid: !(0, _ValidationUtils.isValid)(validation, 'cta'),
        invalidMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.cta, {
          CTA_TEXT_MAX_LENGTH: _DynoValidation.CTA_TEXT_MAX_LENGTH
        }),
        value: ctaText,
        onChange: this.handleChangeCtaText
      }), this.maybeRenderConsciousCancel(), _react.default.createElement(_UIFormControl.default, {
        className: "private-toggle-group",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('themeColorPickerHeader')
        }),
        tooltip: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('themeColorPickerTooltip')
        })
      }, _react.default.createElement(_DynoEditorSuggestedColors.default, {
        updateColor: this.handleUpdateColor,
        selectedColor: color,
        suggestedColors: suggestedColors,
        loading: fetchingSuggestedColors
      })), _react.default.createElement(_UIFormControl.default, {
        className: "m-top-0 m-bottom-4 label-as-body-text"
      }, _react.default.createElement(_UIColorInput.default, {
        className: "color-picker__input",
        ColorPicker: _ColorPicker.default,
        onColorChange: this.handleUpdateColor,
        color: color
      })), isUngatedForFormlessPopups && this.renderFormlessPopupsOptions());
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        validation: {},
        color: '#1A8FD3'
      };
    }
  }]);
  return DynoCalloutPanel;
}(_react.Component);

exports.default = DynoCalloutPanel;
module.exports = exports.default;